import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

export const DEFAULT_ZOOM = 13;
export const MIN_ZOOM = 10;
export const MAX_ZOOM = 18;

export const CenterLock = ({ center }: { center: { lat: number; lng: number } }) => {
  const map = useMap();
  useEffect(() => {
    if (!map) return;
    const listener = map.addListener("drag", () => map.panTo(center));
    return () => listener.remove();
  }, [map, center]);
  return null;
};
